import { FC } from 'react';
import { Input, ModalProps, Pagination, Space, Table } from 'antd';
import ModalAtom from 'components/atoms/ModalAtom';
import DefaultButton from 'components/atoms/Button/DefaultButton';
import PrimaryButton from 'components/atoms/Button/PrimaryButton';
import { CustomAssetData, ShareSensorOptionsModel } from 'hooks/useShareSensor';
import { TABLE_PAGE_SIZE_DEFAULT_OPTIONS } from 'constants/table';
import { DEFAULT_PAGE_SIZE } from '../AlfredTable';
import './styles.scss';

export interface ShareSensorTranslationsModel {
  title: string;
  mainButtonText: string;
  secondaryButtonText: string;
  selectedAssetsText: string;
  searchText: string;
}

interface Props extends ModalProps {
  modalOptions: ShareSensorOptionsModel;
}

const TABLE_HEIGHT = 400;

const ShareSensorModal: FC<Props> = ({ onCancel, modalOptions, ...props }) => {
  const {
    translations,
    columns,
    assets,
    selectedRowKeys,
    totalPages,
    currentPage,
    currentPageSize,
    onChangeAssetShareSensor,
    onUpdateGatewayWithNewSensors,
    onChangePagination,
    onSearch,
    loading,
    updating,
  } = modalOptions;

  const {
    title,
    mainButtonText,
    secondaryButtonText,
    selectedAssetsText,
    searchText,
  } = translations;

  return (
    <ModalAtom
      {...props}
      title={<Space>{title}</Space>}
      onCancel={onCancel}
      destroyOnClose
      width={'75%'}
      footer={[
        <DefaultButton key={'back'} onClick={onCancel} title={secondaryButtonText} />,
        <PrimaryButton key={'submit'} loading={updating} onClick={onUpdateGatewayWithNewSensors} title={mainButtonText} />,
      ]}
    >
      <div>
        <div className={'ShareSensorModal__tableHeader'}>
          <p className={'ShareSensorModal__tableHeader-text'}>{selectedAssetsText}</p>
          <div className={'ShareSensorModal__search'}>{onSearch && <Input.Search autoFocus allowClear placeholder={searchText} onSearch={onSearch} />}</div>
        </div>
        <Table<CustomAssetData>
          loading={loading}
          columns={columns}
          rowKey={'assetId'}
          dataSource={assets}
          pagination={false}
          bordered
          scroll={{ y: TABLE_HEIGHT }}
          rowSelection={{ selectedRowKeys, onChange: onChangeAssetShareSensor }}
        />
        <Pagination
          className={'ShareSensorModal__pagination'}
          size={'small'}
          showSizeChanger={true}
          defaultPageSize={DEFAULT_PAGE_SIZE}
          pageSizeOptions={TABLE_PAGE_SIZE_DEFAULT_OPTIONS}
          current={currentPage}
          total={currentPageSize * totalPages}
          pageSize={currentPageSize}
          onChange={onChangePagination}
        />
      </div>
    </ModalAtom>
  );
}

export default ShareSensorModal;